import { styled } from '@mui/material/styles';

export const LockIllustration = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  width: 55,
  height: 45,
  backgroundColor: theme.palette.grey[800],
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    borderLeft: `5px solid ${theme.palette.grey[800]}`,
    height: 20,
    width: 15,
    left: 'calc(50% - 12.5px)',
  },
  '&::before': {
    top: -30,
    border: `5px solid ${theme.palette.grey[800]}`,
    borderBottomColor: 'transparent',
    borderRadius: '15px 15px 0 0',
    height: 30,
  },
  '&::after': {
    top: -10,
    borderRight: '5px solid transparent',
  },
}));
